<template>
  <div class="container">
    <!-- Header -->
    <div class="header-section">
      <h1 style="font-size: large">Seller Management</h1>
      <!-- <a-button
        :loading="exportLoading"
        @click="exportExcell"
        style="border-radius: 6px; background: #fff; color: #0f3659"
        icon="upload"
      >
        Export
      </a-button> -->
    </div>

    <!-- Stats Cards -->
    <a-row :gutter="[16, 16]">
      <a-col :span="6" v-for="(card, index) in cards" :key="index">
        <div class="card-wrapper">
          <div class="card-content">
            <div class="card-header">
              <div>
                <h3>{{ card.title }}</h3>
                <p>{{ sellerStats[card.value] || 0 }}</p>
              </div>
              <div
                class="icon-wrapper"
                :style="{ backgroundColor: card.iconBg, color: card.iconColor }"
              >
                <a-icon :class="['fa', card.icon]" />
              </div>
            </div>
            <p class="card-paragraph">
              <span
                v-if="card.spanIcon || card.span"
                :style="{
                  color:
                    card.spanIcon === 'fa-arrow-down' ? '#ef4444' : '#10b981',
                  display: 'inline-flex',
                  alignItems: 'center',
                }"
              >
                <i
                  :class="['fa', card.spanIcon]"
                  style="font-size: 14px; margin-right: 4px"
                ></i>
                {{ card.span }}
              </span>
              {{ card.content }}
            </p>
          </div>
        </div>
      </a-col>
    </a-row>

    <!-- Filters & Search -->
    <div class="filters-section">
      <a-row :gutter="16">
        <a-col :span="8">
          <p style="margin: 0px">Search</p>
          <a-input-search
            v-model="search"
            placeholder="Search by Seller Name or Business Name"
            allow-clear
            style="width: 100%"
          />
        </a-col>
                 <a-col :span="6">
           <p style="margin: 0px">Status</p>
           <a-select
             v-model="filters.status"
             placeholder="All Statuses"
             allowClear
             style="width: 100%"
           >
             <a-select-option value="Active">Active</a-select-option>
             <a-select-option value="Inactive">Inactive</a-select-option>
           </a-select>
         </a-col>
         <a-col :span="6">
           <p style="margin: 0px">KYC Status</p>
           <a-select
             v-model="filters.kycStatus"
             placeholder="All KYC Statuses"
             allowClear
             style="width: 100%"
           >
             <a-select-option value="Approved">Approved</a-select-option>
             <a-select-option value="Pending">Pending</a-select-option>
             <a-select-option value="Rejected">Rejected</a-select-option>
           </a-select>
         </a-col>
        
      </a-row>
    </div>

    <!-- Sellers Table -->
    <div class="table-container">
      <a-table
        :columns="sellerColumns"
        :data-source="sellerData"
        row-key="userSetupId"
        :pagination="tablePagination"
        :scroll="{ x: 'max-content' }"
        :loading="sellerLoading"
        @change="handleTableChange"
        style="background-color: #fafafa"
        :rowClassName="() => 'custom-table-row'"
      >
                 <template slot="actions" slot-scope="text, record">
           <div class="action-buttons">
             <a-button type="link" @click="goToSellerDetails(record)">
               <i class="fa fa-eye" style="color: #9e9e9e" aria-hidden="true"></i>
             </a-button>
           </div>
         </template>
        
        <template slot="status" slot-scope="text">
          <StatusTag :status="text" />
        </template>

        <template slot="kycStatus" slot-scope="text">
          <StatusTag :status="text" />
        </template>

        <template slot="walletStatus" slot-scope="text">
          <StatusTag :status="text ? 'Active' : 'Not Created'" />
        </template>
        
        <template slot="sellerName" slot-scope="text, record">
          <a
            @click="goToSellerDetails(record)"
            style="color: #1890ff; cursor: pointer"
          >
            {{ text }}
          </a>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import sellersService from "../../api/sellers.service";
import StatusTag from "../shared-components/StatusTag.vue";

export default {
  name: "SellerManagement",
  components: {
    StatusTag
  },

  data() {
    return {
      search: "",
        filters: {
         status: undefined,
         kycStatus: undefined,
       },
      searchDebounceTimer: null,
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0,
      },
      sellerColumns: [
        {
          title: "Seller Name",
          dataIndex: "accountDetails.tradingName",
          key: "tradingName",
          scopedSlots: { customRender: "sellerName" },
        },
        {
          title: "Region",
          dataIndex: "accountDetails.operationZone",
          key: "operationZone",
        },
        {
          title: "Seller Phone No",
          dataIndex: "accountDetails.phoneNumber",
          key: "phoneNumber",
        },
        {
          title: "Email",
          dataIndex: "accountDetails.accountEmail",
          key: "accountEmail",
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "KYC Status",
          dataIndex: "accountDetails.sellerApprovalStatus",
          key: "kycStatus",
          scopedSlots: { customRender: "kycStatus" },
        },
        {
          title: "Wallet Status",
          dataIndex: "isWalletLinked",
          key: "walletStatus",
          scopedSlots: { customRender: "walletStatus" },
        },
        {
          title: "Actions",
          key: "actions",
          scopedSlots: { customRender: "actions" },
        },
      ],
      sellerData: [],
      sellerLoading: false,
      cards: [
        {
          title: "Total Sellers",
          value: "totalSellers",
          icon: "fa-users",
          iconColor: "#3b82f6",
          iconBg: "#dbeafe",
        },
        {
          title: "Verified Sellers",
          value: "verifiedSellers",
          icon: "fa-check-circle",
          iconColor: "#10b981",
          iconBg: "#d1fae5",
        },
        {
          title: "Sellers with Active Orders",
          value: "sellersWithActiveOrders",
          icon: "fa-box",
          iconColor: "#f59e0b",
          iconBg: "#fef3c7",
        },
        {
          title: "New Sellers",
          value: "newSellers",
          icon: "fa-user-plus",
          iconColor: "#ef4444",
          iconBg: "#fee2e2",
        },
      ],
      sellerStats: {
        totalSellers: 0,
        verifiedSellers: 0,
        sellersWithActiveOrders: 0,
        newSellers: 0,
      },
    };
  },

  computed: {
    tablePagination() {
      return {
        current: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
        total: this.pagination.totalCount,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} sellers`,
        showSizeChanger: false,
      };
    },


  },

  watch: {
    'pagination.pageIndex'() {
      this.fetchSellers();
    },
    search() {
      if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.pagination.pageIndex = 1;
        this.fetchSellers();
      }, 400);
    },
    filters: {
      handler() {
        this.pagination.pageIndex = 1;
        this.fetchSellers();
      },
      deep: true,
    },
  },

  methods: {
    async fetchSellerStats() {
      try {
        const response = await sellersService.getSellerStats();
        
        if (response.data?.code === 200) {
          this.sellerStats = response.data.data;
        } else {
          console.error("Failed to fetch seller stats:", response.data);
          this.$message.warning("Failed to fetch seller statistics");
        }
      } catch (error) {
        console.error("Error fetching seller stats:", error);
        this.$message.error("Failed to fetch seller statistics");
      }
    },

    async fetchSellers() {
       this.sellerLoading = true;

       try {
         const params = {
           pageIndex: this.pagination.pageIndex,
           pageSize: this.pagination.pageSize,
           status: this.filters.status || "",
           search: this.search || "",
           kycStatus: this.filters.kycStatus || "",
         };

         const response = await sellersService.getAllSellers(params);

         if (response.data?.code === 200) {
           const data = response.data.data;
           this.sellerData = (data.results || []).map((seller) => ({
             id: seller.id,
             userSetupId: seller.userSetupId,
             isWalletLinked: seller.isWalletLinked,
             accountDetails: {
               tradingName: seller.accountDetails?.tradingName || "N/A",
               phoneNumber: seller.accountDetails?.phoneNumber || "N/A",
               accountEmail: seller.accountDetails?.accountEmail || "N/A",
               operationZone: seller.accountDetails?.operationZone || "N/A",
               sellerApprovalStatus: seller.accountDetails?.sellerApprovalStatus || "Pending",
             },
             businessDetails: {
               businessName: seller.businessDetails?.businessName || "N/A",
               businessType: seller.businessDetails?.businessType || "N/A",
               approvalStatus: seller.businessDetails?.approvalStatus || "Pending",
             },
             status: seller.status || "Active",
             createdAt: seller.createdAt,
             updatedAt: seller.updatedAt,
           }));
           
           this.pagination.totalCount = data.totalCount || 0;
           this.pagination.pageIndex = data.pageIndex || this.pagination.pageIndex;
         } else {
           this.sellerData = [];
           this.pagination.totalCount = 0;
           this.$message.warning("No data received from the server");
         }
       } catch (error) {
         console.error("Error fetching sellers:", error);
         this.sellerData = [];
         this.pagination.totalCount = 0;
         
         if (error.response) {
           console.error("Error response:", error.response.data);
           this.$message.error("Failed to fetch sellers. Please try again.");
         } else {
           this.$message.error("Network error. Please check your connection.");
         }
       } finally {
         this.sellerLoading = false;
       }
     },



    handleTableChange(pagination) {
      if (pagination.current !== this.pagination.pageIndex) {
        this.pagination.pageIndex = pagination.current;
      }
    },

    goToSellerDetails(record) {
      this.$router.push({
        name: "SellerDetails",
        params: {
          userSetupId: record.userSetupId
        },
      });
    },
  },

  mounted() {
    this.fetchSellerStats();
    this.fetchSellers();
  },
};
</script>

<style>
/* Global styles to override Ant Design */
.ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
.ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
.ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
.ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: #fafafa !important;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  background: #fafafa !important;
}
</style>

<style scoped>
.container {
  width: 100%;
  max-width: 100%;
  margin: 0 !important;
  box-sizing: border-box;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.filters-section {
  margin: 40px 0 20px 0;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e6e6e6;
}



.card-wrapper {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  transition: all 0.3s ease;
  height: 100%;
}

.card-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 150ppx;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  background-color: transparent;
  padding: 0;
  border-bottom: none;
}

.card-header p {
  font-weight: 700;
  font-size: 18px;
  color: #000000;
  margin: 0;
}

.card-header h3 {
  font-size: 1em;
  color: #6b7280;
}

.card-paragraph {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  margin: 0;
  line-height: 1.4;
  margin-top: auto;
}

.icon-wrapper {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 12px;
  flex-shrink: 0;
}

.table-container {
  margin-top: 20px;
  width: 100%;
  overflow-x: auto;
}
.action-buttons {
  display: flex;
  gap: 4px; /* adjust this as needed */
  align-items: center;
}

.action-buttons .ant-btn {
  padding: 0 4px;
  height: 24px;
  line-height: 24px;
}



</style>
